import {
  FlexCenter,
  FlexColumn,
  Skeleton,
  SkeletonLine,
  SkeletonRow,
  TextBody,
} from "@opensea/ui-kit"
import { range } from "es-toolkit/math"
import { useTranslations } from "next-intl"

type Props = {
  className?: string
}

export function TraitFiltersSectionSkeleton({ className }: Props) {
  const t = useTranslations("TraitFiltersSection")
  return (
    <FlexColumn className={className}>
      <FlexCenter className="mb-1 min-h-8">
        <TextBody size="sm">{t("title")}</TextBody>
      </FlexCenter>
      <TraitFiltersSectionSkeletonRows />
    </FlexColumn>
  )
}

export const TraitFiltersSectionSkeletonRows = () => {
  return range(10).map(ix => {
    return (
      <Skeleton className="flex-auto py-3" key={ix}>
        <SkeletonRow>
          <SkeletonLine className="h-4 w-1/3" />
          <SkeletonLine className="h-4 w-6" />
        </SkeletonRow>
      </Skeleton>
    )
  })
}
